import React from 'react';
import ReactHotkeys from 'react-hot-keys';
import { motion } from 'framer-motion';
import { WarningIcon, crossIcon, dangerIcon, refreshIcon, tickIcon2 } from '../common/Icons';

const SeeCalculation: React.FC<{
    close: () => void;
    recordCreated: number;
    uniqueRecords: number;
    linkingStatus: {
        linked: number;
        errored: number;
        inprogress: number;
    };
    eligible: number;
}> = ({ close, linkingStatus, recordCreated, uniqueRecords, eligible }) => {
    return (
        <ReactHotkeys keyName="esc" onKeyDown={close}>
            <motion.div
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                style={{ zIndex: 9999 }}
                transition={{ duration: 0.2, ease: 'linear' }}
                className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-lato"
            >
                <div className="modal-overlay" onClick={close}></div>
                <div
                    className="modal-content w-50p flex flex-col"
                    style={{ maxHeight: 'calc(100vh - 125px)', background: 'transparent' }}
                >
                    <div className="flex items-center justify-between bg-white px-16 py-12 rounded-t-8">
                        <p className="text-20 font-400">Eligible records for ABHA: Explanation </p>
                        <span className="cursor-pointer" onClick={close}>
                            {crossIcon('w-14 h-14')}
                        </span>
                    </div>
                    <div className="flex overflow-auto hide-scrollbar w-full flex-col p-16 gap-16 bg-darwin-neutral_new-50">
                        <div className="flex gap-16 p-24 w-full bg-white rounded-8">
                            <span className="flex flex-col items-start gap-8">
                                <span className="text-24 font-700">{recordCreated}</span>
                                <span className="text-13 font-400">Records Created</span>
                            </span>
                            <div className="flex px-12 py-4 items-center justify-start ml-auto rounded-8 bg-darwin-neutral_new-50">
                                <p className="text-14">
                                    Total records added by you against your patients with ABHA ID
                                    this month
                                </p>
                            </div>
                        </div>
                        <div className="flex w-full p-24 bg-white flex-col gap-16 rounded-8">
                            <div className="flex flex-wrap justify-between gap-16 w-full">
                                <div className="flex gap-8 items-center">
                                    <span className="border border-darwin-green-primary flex items-center justify-center rounded-full">
                                        {tickIcon2('fill-darwin-green-primary font-700 w-16 h-16')}
                                    </span>
                                    <p>
                                        Unique Records Linked:{' '}
                                        <span className="font-700">
                                            {uniqueRecords.toLocaleString('en-IN')}
                                        </span>
                                    </p>
                                </div>
                                <div className="flex gap-8 items-center">
                                    <span className="flex items-center justify-center rounded-full">
                                        {refreshIcon(
                                            'fill-darwin-accent-bright-yellow-800 font-700 w-16 h-16',
                                        )}
                                    </span>
                                    <p>
                                        Linking in progress:{' '}
                                        <span className="font-700">
                                            {linkingStatus.inprogress.toLocaleString('en-IN')}
                                        </span>
                                    </p>
                                </div>
                                <div className="flex gap-8 items-center">
                                    <span className="flex items-center justify-center rounded-full">
                                        {dangerIcon('w-16 h-16')}
                                    </span>
                                    <p>
                                        Error in linking:{' '}
                                        <span className="font-700">
                                            {linkingStatus.errored.toLocaleString('en-IN')}
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div className="flex w-full p-12 items-center justify-start rounded-8 bg-darwin-neutral_new-50">
                                <p className="text-14">
                                    Unique records are records left after applying the DHIS criteria
                                    of linking 1 record per patient per day and a maximum of 5
                                    records per month
                                </p>
                            </div>
                        </div>
                        {/* <div className="abha-linked-inner-more flex flex-col gap-16 p-24 w-full rounded-8">
                            <span className="flex flex-col items-start gap-8">
                                <span className="text-24 font-700">
                                    {uniqueRecords - 100 < 0 ? 0 : uniqueRecords - 100}
                                </span>
                            </span>
                            <p className="text-13">
                                Eligible Records (Unique Records Linked - DHIS Cutoff: 100)
                            </p>
                        </div> */}
                    </div>
                    <div className="w-full rounded-b-8 flex border-t border-darwin-neutral_new-200 flex-col items-center">
                        <div
                            className={`flex justify-center px-16 py-12 items-center bg-white w-full rounded-b-8`}
                        >
                            <div
                                onClick={close}
                                className="cursor-pointer flex rounded-8 font-700 px-12 py-6 justify-center items-center bg-white bg-darwin-accent-bright-blue-800 text-white"
                            >
                                Ok, Got it!
                            </div>
                        </div>
                    </div>
                </div>
            </motion.div>
        </ReactHotkeys>
    );
};

export default SeeCalculation;
